import { Provider } from "react-redux";
import { WinstonProvider } from "winston-react/dist/context";
import { logger } from "@tecma/logs-fe";
import Tracking from "components/Tracking/Tracking";
import { storeFactory } from "../../store";
import { ProviderEnvironment } from "./ProviderEnvironment";
import { ProviderGraphQl } from "./ProviderGraphQl";

export const Providers = ({ children }: { children: React.ReactNode }) => {
  const store = storeFactory();

  return (
    <Provider store={store}>
      <ProviderEnvironment>
        <ProviderGraphQl>
          <WinstonProvider logger={logger}>
            <Tracking />
            {children}
          </WinstonProvider>
        </ProviderGraphQl>
      </ProviderEnvironment>
    </Provider>
  );
};
